import { GoogleSession, OneLoginSession } from '../../types'

export function getSession(): GoogleSession | OneLoginSession | null {
  const session = localStorage.getItem('TD_INTERNAL_SESSION')
  if (session) {
    return JSON.parse(session) as GoogleSession | OneLoginSession
  }
  return null
}
